// Obsolote 2026-03-25: TemplateDirection should be calculated based on content.
export enum DistributionTemplateDirection {
    In = "In",
    Out = "Out"
}
